import { moveItem } from "./sort";
import { hasSmartlistModuleNameParamsComponent } from "./typePredicate";

import type { PlatformComponent } from "../api/ProjectAPI.types";

export const SEARCH_RESULT_MODULE_NAME_LIST = [
  "search_media",
  "search_smartlist",
  "search_fast",
  "search_casting",
] as const;

export type SearchResultModuleName =
  (typeof SEARCH_RESULT_MODULE_NAME_LIST)[number];

export interface SearchResultComponent {
  rank: number;
  static_component: { smartlist_module_name: SearchResultModuleName };
}

// Rank 0 = placeholder, rank 1 = affichage par défaut (marqueur).
const FIRST_SEARCH_RESULT_RANK = 2;

export function isSearchResultComponent<T extends PlatformComponent>(
  component: T,
): component is T & SearchResultComponent {
  return (
    hasSmartlistModuleNameParamsComponent(component) &&
    SEARCH_RESULT_MODULE_NAME_LIST.some(
      (moduleName) =>
        moduleName === component.static_component.smartlist_module_name,
    )
  );
}

export function sortSearchResultComponents<T extends SearchResultComponent>(
  componentList: T[],
): T[] {
  return [...componentList].sort(
    (componentA, componentB) =>
      componentA.rank - componentB.rank ||
      SEARCH_RESULT_MODULE_NAME_LIST.indexOf(
        componentA.static_component.smartlist_module_name,
      ) -
        SEARCH_RESULT_MODULE_NAME_LIST.indexOf(
          componentB.static_component.smartlist_module_name,
        ),
  );
}

export function reorderSearchResultComponents<T extends SearchResultComponent>(
  componentList: T[],
  sourceIndex: number,
  destinationIndex: number,
): T[] {
  if (sourceIndex < 0 || sourceIndex >= componentList.length) {
    return componentList;
  }

  return moveItem(componentList, sourceIndex, destinationIndex).map(
    (component, index) => ({
      ...component,
      rank: index + FIRST_SEARCH_RESULT_RANK,
    }),
  );
}
